import { useMutation } from '@tanstack/react-query'
import { postEmbeddedSignRequest } from '@entities/sign'
import { useAlertStore } from '@shared/store'
import { isEmbeddedSignEnabled } from '@shared/utils'

type RequestEmbeddedSignOptions = {
  signWindow?: Window | null
}

export const useEmbeddedSignRequest = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: postEmbeddedSignRequest,
  })

  const requestEmbeddedSign = ({ signWindow }: RequestEmbeddedSignOptions = {}) => {
    if (!isEmbeddedSignEnabled()) {
      signWindow?.close()
      useAlertStore.getState().push('전자 서명 기능은 준비 중입니다.')
      return
    }

    mutate(undefined, {
      onSuccess: data => {
        if (data.code !== 200) {
          signWindow?.close()
          return
        }

        if (data.status === 'COMPLETED') {
          signWindow?.close()
          useAlertStore.getState().push('전자 서명이 이미 완료되었습니다.')
          return
        }

        if (!data.embeddedUrl) {
          signWindow?.close()
          useAlertStore.getState().push('전자 서명 URL을 발급받지 못했습니다.')
          return
        }

        if (signWindow) {
          signWindow.opener = null
          signWindow.location.href = data.embeddedUrl
          return
        }

        window.open(data.embeddedUrl, '_blank', 'noopener,noreferrer')
      },
      onError: () => {
        signWindow?.close()
      },
    })
  }

  return { requestEmbeddedSign, isPending }
}
